module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "enter-login"
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "phone-login"
  }, [_c('div', {
    staticClass: "text-center animated fadeInDown"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "welcome"
  }, [_vm._v("欢迎登录")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "",
      "role": "form",
      "onsubmit": "return false"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.name),
      expression: "credentials.name"
    }],
    staticClass: "form-control phone numkeyboard",
    attrs: {
      "type": "text",
      "placeholder": "请输入注册手机号",
      "required": "required"
    },
    domProps: {
      "value": (_vm.credentials.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "form-control psw numkeyboard",
    attrs: {
      "type": "password",
      "placeholder": "请输入账号密码",
      "required": "required"
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/psw_forgot"
    }
  }, [_c('button', {
    staticClass: "btn btn-forget block full-width",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("忘记密码")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-login block full-width",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../../../assets/img/login.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-8f459844"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/module/main/views/login.vue
// module id = 220
// module chunks = 1